import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('#additional-objects-map', () => {
  void import('./internal/map-view').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.additional_objects_new_page', () => {
  void import('./internal/new').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.additional-objects-show-page', () => {
  void import('./internal/show').then(({ default: Component }) => Component());
});
